export const baseUrl = 'https://api.themoviedb.org/3';
export const API_KEY = ""; // User needs to fill this
export const imageUrl = 'https://image.tmdb.org/t/p/original';
export const MOCK_MODE = true; // Set to true to use local data if API_KEY is missing
